import React from 'react';

const DiscountsContext = React.createContext({
    discounts: null,
    isReady: false

});

export default DiscountsContext;